import { render } from "./app-system-empty.vue?vue&type=template&id=f3494504&scoped=true"
const script = {}

import "./app-system-empty.vue?vue&type=style&index=0&id=f3494504&lang=scss&scoped=true"

import exportComponent from "D:\\shine\\shine-project\\dispatch-big-screen-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3494504"]])

export default __exports__